import styled from 'styled-components'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { CategoryNavAccordion } from '@/features/shop/components/UngatedCategoryPage/CategoryNavAccordion'
import { RetailerSection } from '@/features/shop/components/UngatedCategoryPage/RetailerSection'
import { UngatedCategoryHead } from '@/features/shop/components/UngatedCategoryPage/UngatedCategoryHead'
import { ProductGridWrapper } from '@/features/shop/components/UngatedCategoryPage/ProductGridWrapper'
import { Box } from '@shipt/design-system-layouts'
import { screenSizes } from '@shipt/design-system-themes'
import { ProductGridHeading } from '@/features/shop/components/UngatedCategoryPage/ProductGridHeading'

export const UngatedCategoryPage = () => {
  return (
    <>
      <UngatedCategoryHead />
      <GridLayoutContainer contentMaxWidth>
        <Grid>
          <ProductGridHeading className="heading" />
          <Box className="nav" as="nav" aria-label="Category Navigation">
            <CategoryNavAccordion />
          </Box>
          <ProductGridWrapper className="productGrid" />
        </Grid>
      </GridLayoutContainer>
      <RetailerSection />
    </>
  )
}

const Grid = styled.div`
  display: grid;
  margin: 2rem 0;
  grid-template-columns: [nav] 15rem [content] 1fr [end-col];
  grid-template-rows: [heading] auto [content] 1fr [last-row];
  column-gap: 2rem;

  .nav {
    display: none;
  }

  .heading {
    grid-column: nav / end-col;
  }

  .productGrid {
    grid-column: nav / end-col;
    grid-row-start: content;
  }

  @media ${screenSizes.tablet} {
    .nav {
      display: block;
      grid-column: 1 / content;
      grid-row: 1 / last-row;
    }

    .heading {
      grid-column: content / end-col;
    }

    .productGrid {
      grid-column-start: content;
      grid-row-start: content;
    }
  }
`
